import { TDefaultTheme } from '@lib/theme/defaultTheme';
import styled from 'styled-components';

export const PaperSC = styled.div<{
  variant?: keyof TDefaultTheme['color']['surface'];
  type?: 'rounded' | 'default';
}>`
  background-color: ${({ theme, variant }) => theme.color.surface[variant ?? 'baseline']};
  border-radius: ${({ theme, type }) => (type === 'rounded' ? theme.radius.extraLarge : 0)}px;
`;
